<template>
  <fragment>
    <Title title="服务下单渠道分析"></Title>
    <div class="layout-view withoutTitle">
      <EchartsLayout :option="option"></EchartsLayout>
    </div>
  </fragment>
</template>

<script>
import { getCacheOrRequest } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import Title from "@/components/common/Title.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    Title,
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "get",
        url: `/home/getOrderBuyOriginWithMonth`,
        success: (response) => {
          let arr = [];
          for (let i = 1; i <= 12; i++) {
            arr.push({ 月份: `${i}月`, 平台下单: 0, 自主下单: 0 });
          }
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              if (!isNaN(item.month) && item.month > 0 && item.month < 13) {
                if (item.origin == "平台") {
                  arr[item.month - 1]["平台下单"] = item.allNum;
                } else if (item.origin == "自主") {
                  arr[item.month - 1]["自主下单"] = item.allNum;
                }
              }
            });
          this.option = {
            grid: { containLabel: true, right: 0, bottom: 0, top: 100, left: 0 },
            series: [
              { type: "line", name: "平台下单", ecode: { x: "月份", y: "平台下单" } },
              { type: "line", name: "自主下单", ecode: { x: "月份", y: "自主下单" } },
            ],
            tooltip: { textStyle: { fontSize: 30 }, trigger: "axis" },
            xAxis: {
              type: "category",
              axisLabel: {
                textStyle: {
                  fontWeight: 700,
                  fontSize: 54,
                },
              },
            },
            yAxis: {
              axisLabel: {
                textStyle: {
                  fontWeight: 700,
                  fontSize: 54,
                },
              },
            },
            legend: {
              show: true,
              itemWidth: 50,
              itemHeight: 50,
              height: "40%",
              width: "100%",
              textStyle: {
                fontWeight: 700,
                fontSize: 54,
              },
            },
            dataset: {
              source: [...arr],
            },
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
